export const PLAYFIELD = {
  halfWidth: 18,
  halfHeight: 24,
  spawnY: 27,
  despawnY: -27,
} as const;

export const SIMULATION = {
  fixedDelta: 1 / 60,
  maxEnemyBullets: 1200,
  maxPlayerShots: 256,
  maxEnemies: 120,
} as const;

export const COLORS = {
  hostile: '#ff5b38',
  hostileCore: '#fff0cf',
  // Lattice Growth — cold glacial cyan. Complement of the hostile-fire
  // band so Growth and enemy bullets never blur together at speed.
  lattice: '#7fd8ec',
  player: '#dffcff',
  reward: '#f7c757',
  // Afterburner heat. Nothing reads this today, but it stays correct so a
  // future consumer cannot resurrect the green exhaust.
  engine: '#ffd9a8',
} as const;
